"use client";

import { useQuery } from "@tanstack/react-query";

import { getPriorAuthorizationsByReferralId } from "@/src/requests/prior-authorization";

export const PRIOR_AUTHORIZATIONS_BY_REFERRAL_CACHE_KEY = "prior-authorizations-by-referral";

export function usePriorAuthorizationsByReferralId(referralId: string | null) {
  const query = useQuery({
    queryKey: [PRIOR_AUTHORIZATIONS_BY_REFERRAL_CACHE_KEY, referralId],
    queryFn: () => {
      if (!referralId) return [];

      return getPriorAuthorizationsByReferralId(referralId);
    },
    enabled: !!referralId,
  });

  return {
    priorAuthorizations: query.data ?? [],
  };
}
